const lan = {
  REDIRECT: "กำลังดำเนินการ...",
  RULE: {
    SERVICE_TYPE: "กรุณาเลือกประเภทของบริการ",
    COUNTRY: "โปรดเลือกประเทศหรือภูมิภาคของคุณ",
    USERNAME: "กรุณาระบุชื่อผู้ใช้งาน",
    EMAIL: "กรุณาใส่อีเมล",
    EMAIL2: "กรุณาใส่อีเมลให้ถูกต้อง",
    PRODUCT: "กรุณาเลือกผลิตภัณฑ์ของคุณ",
    PRODUCTSN: "กรณาระบุหมายเลขซีเรียลของคุณ",
    PRODUCTSN_LEN: "กรุณาใส่ตัวอักษรหรือตัวเลข 12 ถึง 15 ตัว",
    BIRTHDAY: "กรุณาใส่วันเกิด",
    REQUIRED: "กรุณาระบุ",
  },
  SYS: {
    HEAD: "ระบบ",
    NOSERVICE:
      "ขออภัย การสนทนาออนไลน์ในประเทศหรือภูมิภาคที่คุณเลือกไม่สามารถใช้งานได้.",
    CHECK_FILESIZE: "กรุณาตรวจสอบขนาดของรูปภาพหรือไฟล์แนบ ขนาดไม่เกิน:",
    RECONNECTED: "สถานะการเชื่อมต่อกลับมาเป็นปกติ",
    UNABLE_SEND: "ไม่สามารถส่งไฟล์แนบ",
    NO_NETWORK: "ไม่มีการเชื่อมต่ออินเทอร์เน็ต",
    NO_NETWORK_INFO:
      "ไม่มีการเชื่อมต่ออินเทอร์เน็ต กรุณาเชื่อมต่อใหม่และลองอีกครั้ง",
  },
  IDLE: {
    HEAD: "คุณไม่ได้ใช้งานมาระยะหนึ่งแล้ว คุณต้องการสนทนาต่อหรือไม่?",
    BUTTON: "ดำเนินการต่อ",
  },
  DISCONNECT: {
    HEAD: "การสนทนาเสร็จสิ้น",
    BUTTON: "เสร็จสิ้น",
  },
  LAYOUT: {
    STEP_1: "เลือกผลิตภัณฑ์",
    STEP_2: "เงื่อนไขการบริการ",
    STEP_3: "ลงชื่อเข้าใช้",
    STEP_4: "รายละเอียด",
    SELECT_SKILL: "เลือกผลิตภัณฑ์",
    PREV_STEP: "ก่อนหน้า",
    NEXT_STEP: "ถัดไป",
    NOTSET: "ไม่ได้ตั้งค่า",
    AGREEN: "ยอมรับ",
    NOTAGREEN: "ไม่ยอมรับ",
    LEAVE: "ออก",
    TYPE_HERE: "พิมพ์ที่นี่",
    CHAT_DOWNLOAD:
      "คลิกที่นี่เพื่อบันทึกประวัติการสนทนาของคุณกับเจ้าหน้าที่ออนไลน์แชทของ ASUS.",
  },
  COUNTRY: { SELECT_COUNTRY: "โปรดเลือกประเทศหรือภูมิภาคที่ให้บริการ" },
  POLICY: {
    PRIVACY: "นโยบายคุ้มครองความเป็นส่วนตัว",
    SAT_SURVEY: "สัญญาการให้บริการ",
    CONFIRM_COUNTRY: {
      H1: "สวัสดี",
      P1:
        "ท่านกำลังเข้าสู่บริการ ASUS ออนไลน์แชท ประเทศออสเตรเรีย  ซึ่งแตกต่างจากภูมิภาคปัจจุบันของคุณ ตามข้อกำหนดการรับประกันของ ASUS ไม่ใช่ทุกผลิตภัณฑ์ของ ASUS จะใช้ได้กับการรับประกันและการบริการระหว่างประเทศของ ASUS หากไซต์ภูมิภาคด้านบนที่คุณเยี่ยมชมไม่ใช่ภูมิภาคที่คุณซื้อผลิตภัณฑ์ ASUS หรือแตกต่างจากภูมิภาคปัจจุบันของคุณ อาจส่งผลกระทบต่อสิทธิ์การรับประกันของคุณ คุณสามารถใช้ ASUS ออนไลน์แชทสำหรับออสเตรเลียต่อไป หรือเปลี่ยน ASUS ออนไลน์แชทเป็นภูมิภาคของคุณ",
      P2: "",
      P3: "",
      B1: "เปลี่ยนไปใช้ ASUS",
      B2: "เว็บไซต์",
      B3: "ใช้งานต่อ",
    },
    BULLETIN: {
      HEAD: "การแจ้งเตือนข้อความสำคัญ",
      CONFIRM: "รับทราบ",
    },
  },
  SURVEY: {
    SURVEY_ENTER: "โปรดระบุรายละเอียดสำหรับติดต่อของคุณ",
    SURVEY_TYPE: "กรุณาเลือกประเภทบริการ",
    PROBLEM_BRIEF: "กรุณาอธิบายปัญหาของคุณ?",
    TYPE1: "คำถามทั่วไป",
    TYPE2: "สอบถามเกี่ยวกับการซ่อม",
    TYPE3: "ความช่วยเหลือทางเทคนิค",
    TYPE4: "สอบถามเกี่ยวกับการรับประกัน",
    TYPE5: "ความคิดเห็นและข้อเสนอแนะ",
    EC_TYPE1: "ข้อมูลผลิตภัณฑ์และการขาย",
    EC_TYPE2: "กิจกรรมส่งเสริมการขาย",
    EC_TYPE3: "สถานะการจัดส่งและการสั่งซื้อ",
    EC_TYPE4: "บริการส่งคืนสินค้า",
    SIGNUPDATA: "ข้อมูลการลงทะเบียนของคุณ",
    NAME: "ชื่อ",
    TEL: "หมายเลขโทรศัพท์",
    ORDER_NO: "Order No.",
    BIRTHDAY: "วันเดือนปีเกิด",
    LABEL_EMAIL: "Email",
    EMAIL: "อีเมล",
    DEVICEINFO: "ข้อมูลผลิตภัณฑ์ของคุณ",
    DEVICENAME: "ชื่อผลิตภัณฑ์",
    MY_DEVICE: "ผลิตภัณฑ์ของคุณ",
    MY_DEVICE_SELECT: "เลือกผลิตภัณฑ์ของคุณ",
    MY_DEVICE_EMPTY: "คุณยังไม่มีอุปกรณ์ใดๆ",
    LABEL_DEVICESN: "Serial Number",
    DEVICESN: "หมายเลขซีเรียล",
    DEVICESN_ERROR: "หมายเลข SN ของผลิตภัณฑ์ไม่ถูกต้อง.",
    PREPARE: "กำลังสร้างห้องสนทนา เตรียมพร้อมสำหรับการสนทนา",
    START: "เริ่มการสนทนา",
    AGE_LIMIT: "อายุไม่ต่ำกว่า",
    AGE_LIMIT_DESC: "คุณอายุไม่ถึงเกณฑ์ที่จะใช้บริการ ASUS แชทออนไลน์",
    REPEAT_ENTRY: {
      H1: "ตรวจสอบพบว่ามีห้องสนทนาเปิดอยู่แล้ว",
      P1:
        "คุณแน่ใจหรือไม่ว่าต้องการเริ่มการสนทนาใหม่? เมื่อเปิดการสนทนาใหม่ การสนทนาเก่าจะสิ้นสุดลง",
      B0: "ยืนยัน",
      B1: "ยกเลิก",
    },
  },
  CONNECTTING: {
    P1: "กรุณารอสักครู่และอย่าปิดหน้าต่างสนทนานี้",
    P2: "ASUS ออนไลน์แชทกำลังเชื่อมต่อคุณกับเจ้าหน้าที่",
    NOTE: "คำเตือน",
    BEFORE_LEAVE: "คุณแน่ใจหรือไม่ว่าต้องการยกเลิก ASUS ออนไลน์แชท?",
    B0: "เสร็จสิ้น",
    B1: "กรุณารอสักครู่และอย่าออกจากหน้านี้",
  },
  OFFLIEN: {
    OTHER_CONTACT: "ติดต่อ ASUS ผ่านช่องทางอื่นๆ",
    MAIL: "ส่งอีเมลถึงเรา",
    TEL: "โทรหาเรา",
    CLOSE: "ปิด",
  },
  WAITTING: {
    WATTING_NUM: "ลำดับคิว",
    PEOPLE: "ลูกค้า",
    NOTE: "การเตือน",
    BEFORE_LEAVEL: "คุณแน่ใจหรือไม่ว่าต้องการออกจากคิว?",
    LEAVE_DESC: "หากคุณต้องการออกจากคิว คุณสามารถจบการแชทได้",
    LEAVE: "จบการแชท",
    STAY: "รออยู่ในคิว",
  },
  CHATROOM: {
    TYPING: "เจ้าหน้าที่กำลังพิมพ์...",
    HEAD: {
      CLOSE_AMD_SURVEY: "สิ้นสุดการสน",
      TERMINATE: "จบการแชท",
    },
    FOOTER: { CHAT_FINISH: "การสนทนาเสร็จสิ้น" },
    FINISH:
      "การสนทนาเสร็จสิ้น คุณต้องการความช่วยเหลือหรือบริการอื่นๆเพิ่มเติมหรือไม่?",
    SAT_SURVEY: {
      SAT: "พึงพอใจ",
      DISSAT: "ไม่พอใจ",
      SAT_CHOOSE: "บริการประเภทใด? (หลายรายการ)",
      HEAD: "คุณพึงพอใจกับบริการแชทหรือไม่?",
      DESC:
        "การรับฟังความคิดเห็นของคุณเป็นแรงผลักดันในการพัฒนาอย่างต่อเนื่องของเรา โปรดแจ้งให้เราทราบหากคุณมีคำแนะนำสำหรับการบริการหรือการสนับสนุนของ ASUS",
      OTHER_OPTION: "เหตุผลอื่นๆ",
      OTHER_REASON: "กรุณาใส่เหตุผลอื่นๆ",
      SEND: "ส่ง",
    },
    CLOSE: {
      TITLE: "คุณแน่ใจว่าหรือไม่ ว่าต้องการออกจากแชทนี้?",
      P1:
        'คลิก "เสร็จสิ้น" เพื่อปิดหน้าต่างการสนทนา หากคุณต้องการใช้บริการแชทอีกครั้ง กรุณาคลิก "เริ่มการสนทนาใหม่" .',
      B0: "เสร็จสิ้น",
      B1: "ยกเลิก",
    },
  },
  ERROR: {
    H1: "ไม่มีห้องสนทนานี้หรือการสนทนาเสร็จสิ้นไปแล้ว",
    CLOSE: "ปิดหน้าต่างนี้",
  },
  CHAT_END: {
    H1: "การสนทนาสิ้นสุด ขอบพระคุณที่ใช้บริการ",
    CLOSE: "ปิดหน้าต่างนี้",
  },
  CHAT_CLOSE: {
    H1:
      "เครือข่ายอินเทอร์เน็ตของคุณหยุดทำงานนานกว่า 300 วินาที เราจึงยุติการสนทนานี้",
    DESC:
      "หากคุณใช้เครือข่ายไร้สายหรือเครือข่ายมือถือ โปรดลองค้นหาตำแหน่งที่มีสัญญาณดีกว่า หรือเปลี่ยนไปใช้การเชื่อมต่อเครือข่ายแบบมีสาย ขออภัยในความไม่สะดวก",
    CLOSE: "ปิดหน้าต่างนี้",
  },
  SURVEY_DONE: {
    H1: "ขอบคุณสำหรับการทำแบบสำรวจความพึงพอใจในการให้บริการ",
    P1:
      'คำติชมของคุณคือแรงผลักดันให้เราพัฒนาปรับปรุงอย่างต่อเนื่อง ขอขอบคุณที่สละเวลาตอบแบบสำรวจความพึงพอใจในบริการ หากคุณต้องการรับบริการหรือการสนับสนุนเพิ่มเติม โปรดคลิก "เริ่มแชทใหม่" โปรดคลิก "ปิดหน้าต่าง" เพื่อสิ้นสุดการแชท หากเราได้แก้ไขปัญหาหรือข้อสงสัยของคุณแล้ว',
    AGAIN: "เริ่มการแชทใหม่",
    CLOSE: "ปิดหน้าต่างนี้",
    YT_H1: "ค้นพบเคล็ดลับและความรู้ด้านเทคนิคด้วยวิดีโอสนับสนุนของ ASUS",
    YT_H2: "คลิกเพื่อสำรวจ!",
  },
  AGENT_OFFLINE: {
    H1:
      "การเชื่อมต่ออินเทอร์เน็ตของเจ้าหน้าที่ไม่ตอบสนอง ขณะนี้การแชทของคุณถูกรบกวน",
    H2: "กรุณาอย่าปิดหน้าต่างนี้ เรากำลังพยายามกลับสู่หน้าแชทของคุณ",
    DESC:
      'คุณสามารถเลือกที่จะจบการสนทนานี้หรือคลิก "เริ่มแชทใหม่" และเราจะให้เจ้าหน้าที่ท่านใหม่มาสนทนากับคุณต่อ ขออภัยในความไม่สะดวก',
    AGAIN: "เริ่มแชทใหม่",
  },
  VIDEOCALL: {
    MEDIA_NOTALLOW: "ไม่สามารถใช้กล้องและไมโครโฟนได้",
    H1: "พร้อมที่จะเข้าร่วมหรือยัง?",
    P1:
      "เพื่อให้เจ้าหน้าที่ฝ่ายบริการลูกค้าของ ASUS ช่วยคุณแก้ไขปัญหาได้อย่างมีประสิทธิภาพมากขึ้น คุณต้องอนุญาตให้อุปกรณ์เข้าถึงกล้องและไมโครโฟนของคุณเพื่อเข้าร่วมห้องแชทวิดีโอ และโปรดตรวจสอบให้แน่ใจว่าการเชื่อมต่อเครือข่ายมือถือของคุณเสถียรและทำงานได้ตามปกติ",
    P2:
      "หลังจากเข้าถึงแล้ว คุณยังสามารถตั้งค่าสวิตช์เลนส์และปิดเสียงไมโครโฟนได้อย่างอิสระ",
    VIDEO_STATE: "สถานะวิดีโอ",
    VIDEO_ON: "เปิด",
    VIDEO_OFF: "ปิด",
    AUDIO_STATE: "สถานะเสียง",
    AUDIO_ON: "เปิด",
    AUDIO_OFF: "ปิด",
    ENTER: "เข้าร่วม",
    HANGUP: {
      H1: "วางสาย",
      P1: "คุณต้องการที่จะวางสายวิดีโอแชทใช่ไหม?",
      CONFIRM: "ยืนยัน",
      CANCEL: "ยกเลิก",
    },
    END: {
      H1: "วิดีโอคอลสิ้นสุด",
      P1:
        "ขอบคุณที่ใช้บริการ วิดีโอคอลนี้ได้สิ้นสุดลงแล้ว คุณสามารถปิดหน้าต่างนี้",
    },
  },
  GPT: {
    LAYOUT: {
      STEP_1: "เลือกผลิตภัณฑ์",
      STEP_2: "เงื่อนไขการบริการ",
      STEP_3: "ลงชื่อเข้าใช้",
      STEP_4: "รายละเอียด",
      SELECT_SKILL: "เลือกผลิตภัณฑ์",
      WELCOME: "ยินดีต้อนรับ",
      AGREE: "ยอมรับ",
      START: "เริ่มต้น",
      CANCEL: "ยกเลิก",
      WAIT: "กรุณารอสักครู่",
      INPUT: "พิมพ์ข้อความ",
      TRANSFER_TOAGENT: "ติดต่อเจ้าหน้าที่",
      READMORE:
        "คุณสามารถอ้างอิงหัวข้อ FAQ ที่เกี่ยวข้องต่อไปนี้ ขอบคุณที่ใช้บริการ",
      COLLAPSE: "ซ่อน",
      INPUT_SN: "กรุณาใส่หมายเลขซีเรียลอีกครั้ง",
      YOU_MAY_ALSO: "หากคุณต้องการสอบถามเพิ่มเติม:",
      FOR_FURTHER: "สำหรับข้อมูลเพิ่มเติม กรุณาดูที่:",
      RECORDING: "กรุณาเริ่มพูดได้เลย...",
      RECORDING_NOT_SUPPORTED:
        "เบราว์เซอร์ของคุณไม่รองรับการจดจำเสียงพูด",
      RECORDING_NOT_FOUND:
        "ไม่พบอุปกรณ์บันทึกเสียง กรุณาตรวจสอบไมโครโฟนและสิทธิ์การเข้าถึง",
    },
    IS_COMPONENT_SN:
      "The input is the component serial number, you should enter the correct machine serial number.",
    WARRANTY: {
      SERIES: "ประเภทสินค้า",
      MODEL: "ชื่อสินค้า",
      SERIALNO: "หมายเลขซีเรียลของสินค้า",
      STATUS: "สถานะการรับประกัน",
      DATE: "วันที่หมดประกัน",
    },
    HEAD: {
      LEAVE: "ออกจากการสนทนา",
      CREATE_NEW: "สร้างห้องสนทนาใหม่",
    },
    ENTRANCE: {
      POLICY: "นโยบายความเป็นส่วนตัว",
      AGREE: "คลิก ยอมรับ เพื่อเริ่มการสนทนา",
    },
    MESSAGE: {
      WAIT: "กรุณารอสักครู่ เรากำลังตรวจสอบวิธีแก้ปัญหาให้กับคุณ",
    },
    END: "สิ้นสุดการสนทนา",
    END_MSG: "ASUS ยินดีให้บริการ การสนทนาได้สิ้นสุดลงแล้ว",
    END_SURVEY: "แบบสำรวจความพึงพอใจ",
    END_SURVEY_MSG: "ASUS ยินดีให้บริการ การสนทนาได้สิ้นสุดลงแล้ว",
    BACKHOME: "กลับสู่หน้าหลัก",
    SURVEY: {
      DESC: "กรุณาให้คะแนนความพึงพอใจต่อผู้ช่วยเสมือนจริงของ ASUS",
      SAT: "พึงพอใจ",
      DISSAT: "ไม่พึงพอใจ",
      FEEDBACK: "กรุณากรอกความคิดเห็นของคุณ",
      SEND: "ส่ง",
      BACK: "ยกเลิก",
    },
    SURVEY_DISLIKE: {
      H1: "กรุณาบอกเหตุผลที่คุณไม่พึงพอใจต่อคำตอบ?",
      P: "ความคิดเห็นของคุณช่วยให้เราพัฒนาและปรับปรุงคุณภาพการให้บริการของเรา",
      BUTTON: "ส่ง",
    },
    HISTORY: {
      TITLE: "ประวัติแชท",
      AGO: "{hours} ชั่วโมงที่ผ่านมา",
      CONTINUE: "สนทนาต่อ",
      CLOSE: "การสนทนาได้ถูกปิดแล้ว",
      RESTART: "เริ่มต้นใหม่ด้วยผู้ช่วยเสมือน",
      NON_SERVICE: "นอกเวลาให้บริการ",
      VIEW_HISTORY: "คลิกเพื่อดูประวัติการแชทล่าสุด.",
    },
  },
};
export default lan;
